import { request } from '@/service/cdn_config'

const getChatConfig = () => request('pages/chat_list/config')

export default {
    getChatConfig
}